class CartProgressBar extends HTMLElement {
  constructor() {
    super();
    this.renderCartProgressBar = this.renderCartProgressBar.bind(this);
  }
  connectedCallback() {
    this.renderCartProgressBar();
  }
  renderCartProgressBar(retryCount = 0) {
    const isAwaitingFreshCartData =
      (window.__cartNeedsPromotionRefresh || window.__promotionValidateInFlight) && retryCount < 12;
    if (isAwaitingFreshCartData) {
      setTimeout(() => this.renderCartProgressBar(retryCount + 1), 80);
      return;
    }

    const url =
      typeof theme !== 'undefined' && theme.routes && theme.routes.root_url
        ? `${theme.routes.root_url}?section_id=helper-cart-progress-bar`
        : '/?section_id=helper-cart-progress-bar';
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const freshInner = doc.querySelector('[data-js-cart-progress-bar]');
        if (!freshInner) return;
        const hosts = document.querySelectorAll('[data-js-cart-progress-bar]');
        hosts.forEach((host) => {
          host.innerHTML = freshInner.innerHTML;
        });
        if (typeof window.progressBar === 'function') {
          hosts.forEach((host) => {
            window.progressBar(host);
          });
        }
      })
      .catch(() => {});
  }
}
if (!customElements.get('cart-progress-bar')) {
  customElements.define('cart-progress-bar', CartProgressBar);
}
window.renderCartProgressBar = function () {
  const el = document.querySelector('cart-progress-bar');
  if (el && typeof el.renderCartProgressBar === 'function') {
    el.renderCartProgressBar();
  }
};
